
export enum BookingStatus {
  CONFIRMED = 'CONFIRMADO',
  PENDING = 'PENDENTE',
  CANCELLED = 'CANCELADO',
}

export enum PaymentStatus {
  PAID = 'PAGO',
  PARTIAL = 'PARCIAL',
  PENDING = 'PENDENTE',
}

export interface Booking {
  id: string;
  date: string;
  time: string;
  customerName: string;
  customerEmail: string;
  origin: string;
  tour: string;
  pax: string;
  price: number;
  currency: string;
  status: BookingStatus;
  payment: PaymentStatus;
}

export interface Quote extends Booking {
  createdAt: string;
  expiresAt: string;
}

export interface SidebarItem {
  label: string;
  icon: string;
  path: string;
  section: 'Principal' | 'Operações';
}
